import './biz-icon.scss';
export type TBizIcon =
	| 'TRASH'
	| 'EDIT'
	| 'ARROW-UP'
	| 'ARROW-DOWN'
	| 'ARROW-LEFT-RIGHT'
	| 'ARROW-UP-DOWN'
	| 'COPY'
	| 'DOWNLOAD'
	| 'REFRESH'
	| 'UNDO'
	| 'REDO'
	| 'ADD'
	| 'SAVE'
	| 'STAR_SOLID'
	| 'STAR_LIGHT'
	| 'EXCEL'
	| 'REMOVE'
	| 'CHECK'
	| 'LOADING'
	| 'HOME'
	| 'FOLDER'
	| 'FOLDER_OPEN'
	| 'FLASK'
	| 'VIEW'
	| 'BOOK'
	| 'SCHOOL'
	| 'VIDEO'
	| 'SPELL_CHECK'
	| 'NEWSPAPER'
	| 'IMAGE'
	| 'PAGE'
	| 'DESKTOP'
	| 'MOBILE'
	| 'SEARCH'
	| 'FILE'
	| 'STOP'
	| 'BELL'
	| 'BELL_SLASH'
	| 'BELL_OUTLINE'
	| 'BELL_SLASH_OUTLINE'
	| 'LOCK'
	| 'INVOICE'
	| 'PDF'
	| 'CHART'
	| 'CHART-PIE'
	| 'COMMENT'
	| 'IMPORT'
	| 'LIST'
	| 'SHORTCUT'
	| 'MOVE'
	| 'LINK'
	| 'HISTORY'
	| 'TRIANGLE_EXCLAMATION'
	| 'EYE_SLASH'
	| 'EYE'
	| 'ENVELOPE'
	| 'SHEILD'
	| 'USERS'
	| 'USER'
	| 'UTENSILS'
	| 'GENDER'
	| 'REPLY'
	| 'SETTINGS'
	| 'PLAY'
	| 'EXPAND'
	| 'CONTRACT'
	| 'SEND'
	| 'MAXIMIZE'
	| 'CALENDAR'
	| 'CLOCK'
	| 'CHEVRON-UP'
	| 'CHEVRON-DOWN'
	| 'CHEVRON-RIGHT'
	| 'CHEVRON-LEFT'
	| 'COGS'
	| 'ARCHIVE'
	| 'MAGIC'
	| 'SEO'
	| 'TABLE-LAYOUT'
	| 'PAPER-PLANE';

const icons: Record<TBizIcon, string> = {
	EDIT: 'fa-regular fa-edit',
	ADD: 'fa-solid fa-plus',
	TRASH: 'fa-solid fa-trash-alt',
	'ARROW-UP': 'fa-solid fa-arrow-up',
	'ARROW-DOWN': 'fa-solid fa-arrow-down',
	'ARROW-LEFT-RIGHT': 'fa-solid fa-arrow-right-arrow-left',
	'ARROW-UP-DOWN': 'fa-solid fa-arrow-up-arrow-down',
	COPY: 'fa-regular fa-copy',
	DOWNLOAD: 'fa-regular fa-download',
	REFRESH: 'fa-regular fa-arrows-rotate',
	UNDO: 'fa-solid fa-rotate-left',
	REDO: 'fa-solid fa-rotate-right',
	SAVE: 'fa-solid fa-floppy-disk',
	STAR_SOLID: 'fa-solid fa-star',
	STAR_LIGHT: 'fa-light fa-star',
	REMOVE: 'fa-regular fa-xmark',
	EXCEL: 'fa-regular fa-file-excel',
	CHECK: 'far fa-check',
	LOADING: 'fad fa-spinner-third fa-spin',
	HOME: 'fa-regular fa-house',
	FOLDER: 'fa-solid fa-folder',
	FOLDER_OPEN: 'fa-regular fa-folder-open',
	FLASK: 'fa-solid fa-flask',
	VIEW: 'fa-regular fa-eye',
	EYE: 'fa-solid fa-eye',
	BOOK: 'fa-solid fa-book',
	SCHOOL: 'fa-solid fa-school',
	VIDEO: 'fa-solid fa-video',
	SPELL_CHECK: 'fa-solid fa-spell-check',
	NEWSPAPER: 'fa-solid fa-newspaper',
	IMAGE: 'fa-solid fa-image',
	PAGE: 'fa-solid fa-page',
	DESKTOP: 'fa-solid fa-desktop',
	MOBILE: 'fa-solid fa-mobile-screen-button',
	SEARCH: 'fa-solid fa-search',
	FILE: 'fa-solid fa-file',
	STOP: 'fa-solid fa-stop',
	BELL: 'fa-solid fa-bell',
	BELL_SLASH: 'fa-solid fa-bell-slash',
	BELL_OUTLINE: 'fa-regular fa-bell',
	BELL_SLASH_OUTLINE: 'fa-regular fa-bell-slash',
	LOCK: 'fa-solid fa-lock',
	INVOICE: 'fa-solid fa-file-invoice',
	PDF: 'fa-solid fa-file-pdf',
	CHART: 'fa-solid fa-chart-simple',
	'CHART-PIE': 'fa-duotone fa-solid fa-circle-quarter',
	COMMENT: 'fa-solid fa-comment',
	IMPORT: 'fa-solid fa-file-import',
	LIST: 'fa-solid fa-list',
	SHORTCUT: 'fa-sharp fa-regular fa-square-up-right',
	MOVE: 'fa-solid fa-arrows-alt',
	LINK: 'fa-solid fa-link',
	HISTORY: 'fa-solid fa-rectangle-history',
	TRIANGLE_EXCLAMATION: 'fa-solid fa-triangle-exclamation',
	EYE_SLASH: 'fa-solid fa-eye-slash',
	ENVELOPE: 'fa-solid fa-envelope',
	SHEILD: 'fa-duotone fa-solid fa-shield-quartered',
	USERS: 'fa-solid fa-users',
	USER: 'fa-solid fa-user',
	UTENSILS: 'fa-solid fa-utensils',
	GENDER: 'fa-solid fa-venus-mars',
	REPLY: 'fa-solid fa-reply',
	SETTINGS: 'fa-solid fa-gear',
	PLAY: 'fa-solid fa-play',
	EXPAND: 'fa-solid fa-chevron-down',
	CONTRACT: 'fa-solid fa-chevron-up',
	SEND: 'material-symbols-outlined send',
	MAXIMIZE: 'fa-regular fa-arrows-maximize',
	CALENDAR: 'fa-regular fa-calendar',
	CLOCK: 'fa-regular fa-clock',
	'CHEVRON-UP': 'fa-solid fa-chevron-up',
	'CHEVRON-DOWN': 'fa-solid fa-chevron-down',
	'CHEVRON-RIGHT': 'fa-solid fa-chevron-right',
	'CHEVRON-LEFT': 'fa-solid fa-chevron-left',
	COGS: 'fa-solid fa-cogs',
	ARCHIVE: 'fa-solid fa-archive',
	MAGIC: 'fa-sharp fa-regular fa-wand-magic-sparkles',
	SEO: 'fa-regular fa-magnifying-glass-waveform',
	'TABLE-LAYOUT': 'fa-solid fa-table-layout',
	'PAPER-PLANE': 'fa-solid fa-paper-plane-top',
};

export const getIconClassByType = (iconType: TBizIcon) => {
	return icons[iconType];
};

export const BizIcon = ({ icon, className }: { icon: TBizIcon; className?: string }) => {
	if (icons[icon].includes('material-symbols-outlined')) {
		const iconParts = icons[icon].split(' ');
		return (
			<span className={`biz-icon ${icon.toString().toLowerCase()} ${iconParts[0]} ${className ?? ''}`}>{iconParts[1]}</span>
		);
	}

	return <i className={`biz-icon ${icon.toString().toLowerCase()} ${icons[icon]} ${className ?? ''}`}></i>;
};
